import React from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import createExileGuardTheme from './theme';
import './dashboard.css';

// Import Google Fonts in the ThemeProvider to ensure they're available for the theme
const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Create the theme - this could be expanded to support theme switching if needed
  const theme = createExileGuardTheme();

  return (
    <>
      {/* Add Google Fonts link - ensure Roboto and Roboto Mono are available */}
      <link
        rel='stylesheet'
        href='https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&family=Roboto+Mono:wght@400;500;700&display=swap'
      />

      {/* Apply MUI theme */}
      <MuiThemeProvider theme={theme}>
        {/* CssBaseline normalizes styles */}
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </>
  );
};

export default ThemeProvider;
